import { useCallback, useEffect, useState } from 'react';
import { createSearchParams } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { getKycListEndpoint } from '../services/kycService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';
import { KycItem } from '../models/kycModel';
import { useSelector } from 'react-redux';
import { AppStore } from '../../../redux/store';

const useKyc = () => {
  const { isLoading, callEndpoint } = useCallApiAndLoad();
  // This is to get the search params from the redux store
  const gridSearchBar = useSelector((store: AppStore) => store.gridSearchBar);
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const [kycList, setKycList] = useState<KycItem[]>([]);
  const [paginator, setPaginator] = useState({
    page: 1,
    pageCount: 0,
  });
  const [errorAlert, setErrorAlert] = useState(null);

  const loadKycs = useCallback(
    async (page: number = 0, take: number = 0) => {
      let filterBuilder: any = {};
      if (page > 0) filterBuilder.page = page.toString();
      if (take > 0) filterBuilder.take = take.toString();
      let queryString = '';
      if (gridSearchBar.query) {
        // gridSearchBar.query already contains the "?" at the beginning
        queryString = `${gridSearchBar.query}&${createSearchParams(
          filterBuilder,
        )}`;
      } else {
        queryString = `?${createSearchParams(filterBuilder)}`;
      }

      console.log('queryString', queryString);

      const { status, data } = await callEndpoint(
        getKycListEndpoint(queryString, token),
      );

      const response = fetchResponseAdapter(data);

      if (status === 200) {
        setKycList(response.data.items || []);
        const { page, pageCount } = response.data.meta;
        setPaginator({ page, pageCount });
      } else {
        setErrorAlert(response.message);
      }
    },
    [callEndpoint, token, gridSearchBar],
  );

  useEffect(() => {
    loadKycs().catch((e) => setErrorAlert(e.toString()));
  }, [loadKycs]);

  return {
    kycList,
    isLoading,
    errorAlert,
    loadKycs,
    paginator,
  };
};

export default useKyc;
